var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-framework',{scopedSlots:_vm._u([{key:"title",fn:function(){return [(!!_vm.fields)?_c('div',[_vm._v(" "+_vm._s(_vm.fields.title)+" ")]):_vm._e()]},proxy:true}])},[(_vm.loading)?_c('loader'):_vm._e(),_c('div',{staticStyle:{"max-width":"1200px","width":"100%"},attrs:{"id":"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }